import { TkCheckboxProps } from "../../../type/componentsType/TkCheckbox";
import {
  Checkbox,
  CheckboxProps,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import "./_style.scss";

/**
 * チェックボックス部品
 * TkButtonコンポーネントは、MUIのButtonコンポーネントを拡張したものです。
 * @param {TkCheckboxProps} props - TkCheckboxPコンポーネントのプロパティ
 * @param {string} [props.size="medium"] - TkButtonコンポーネントのsizeプロパティ
 * @param {function} [props.onChange="function"] - チェックボックスを制御するイベント
   @param {string} [props.value=""] - チェックボックスを制御するために必要な値
 * @param rest オプション
 * @returns TkCheckbox
 */
export const TkCheckbox: React.FC<TkCheckboxProps & CheckboxProps> = (
  props
) => {
  const { size = "medium", onChange, errorMessage, label, ...rest } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event);
  };

  return (
    <FormControl>
      <FormControlLabel
        control={
          <Checkbox
            size={size}
            onChange={handleChange}
            inputProps={
              {
                "data-testid": "tkCheckbox",
              } as React.InputHTMLAttributes<HTMLInputElement>
            }
            {...rest}
          />
        }
        label={label}
      />
      {!!errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};

export default TkCheckbox;
